module.exports = __webpack_public_path__ + "static/img/img-10.e68cd2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-10.png
// module id = RxX2
// module chunks = 1